import { DatePipe, JsonPipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  IAmanoOneAccessHolderApiResponse,
  IAmanoOneAccessHolderUpdateResponse,
} from 'src/app/shared/code/interfaces/parcs-interfaces';

@Component({
  selector: 'app-dialog-amano-parcs-exists-new-parker-no-add-access-holder',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatDialogActions,
    MatDialogClose,
    DatePipe,
  ],
  templateUrl: './dialog-amano-parcs-exists-new-parker-no-add-access-holder.component.html',
  styleUrl: './dialog-amano-parcs-exists-new-parker-no-add-access-holder.component.scss',
})
export class DialogAmanoParcsExistsNewParkerNoAddAccessHolderComponent {
  accessHolder: IAmanoOneAccessHolderUpdateResponse = {} as IAmanoOneAccessHolderUpdateResponse;

  constructor(
    public _dialogRef: MatDialogRef<DialogAmanoParcsExistsNewParkerNoAddAccessHolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAmanoOneAccessHolderApiResponse,
  ) {
    this.accessHolder = data.accessHolder;
  }
}
